// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 560) return "static/chunks/560-991327a592bbdc18.js";
	if (chunkId === 607) return "static/chunks/607-d0c51b38c7fee798.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"227":"779fee2d9d02f15a","987":"d0e2a2713a66ed28"}[chunkId] + ".js";
};